<app-banners secaoUrl="sobre"></app-banners>

<section class="p-0">
  <div class="block-video">
    <div class="video-wrapper">
      <div class="video-container">
        <iframe class="video" src="https://www.youtube.com/embed/W4pRwIvGagg?si=Cx7p5qcF6yewPo_y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
  </div>

  <div class="block-images">
    <div class="wrap-max-width">
      <div class="block">
        <h3 class="subtitle mt-1">Unidade Matriz</h3>
        <div class="aspect-ratio-box">
          <img src="/assets/images/04.jpg" alt="" class="imagem" />
        </div>
      </div>
      <div class="block">
        <h3 class="subtitle mt-1">Unidade Plásticos</h3>
        <div class="aspect-ratio-box">
          <img src="/assets/images/03.JPEG" alt="" class="imagem" />
        </div>
      </div>
    </div>
  </div>
  <div class="block-text-one">
    <div class="wrap-max-width">
      <div>
        <h3 class="subtitle mt-1">Inovação que transforma</h3>
        <p class="description">
          Há 35 anos, a Blukit nasceu com um propósito claro: transformar o mercado hidráulico no Brasil.
        </p>
        <p class="description gap-bottom">
          Desde então, a Blukit se destacou pela capacidade de inovar.
          Nossa equipe de engenheiros e técnicos altamente qualificados trabalha incessantemente para desenvolver produtos que atendam às necessidades do mercado e superem as expectativas dos consumidores.
          Esta busca contínua por inovação nos permitiu lançar uma série de produtos pioneiros que se tornaram referência no setor.
        </p>
        <h3 class="subtitle">Qualidade que Garante Confiabilidade.</h3>
        <p class="description">
          Na Blukit, qualidade é um valor fundamental, isso nos traz o reconhecimento de nossos parceiros e clientes.
        </p>
      </div>
      <img src="/assets/images/PACKSHOT_CAPA2024-2-Photoroom.png" alt="" class="imagem-desktop" />
    </div>
  </div>

  <div class="image-mobile-block-one">
    <img src="/assets/images/PACKSHOT_CAPA2024-2-Photoroom.png" alt="" class="imagem-mobile" />
  </div>

  <div class="block-text-two">
    <div class="wrap-max-width">
      <div class="box-image-two">
        <img src="/assets/images/02.jpg" alt="" class="imagem-desktop" />
        <p class="legenda">Energia fotovoltaica na Unidade Plásticos</p>
      </div>
      <div class="block-content d-flex">
        <div class="">
          <h3 class="subtitle">Sustentabilidade e Responsabilidade Social</h3>
          <p class="description gap-bottom">
            Estamos comprometidos com a sustentabilidade e a responsabilidade social.
            Nossos processos produtivos são desenvolvidos com foco na redução de impacto ambiental,
            e implementamos programas que promovem a reciclagem e o uso racional de recursos.
          </p>
        </div>

        <div class="block-image-mobile-two">
          <img src="/assets/images/02.jpg" alt="" class="imagem-mobile" />
          <p class="legenda">Energia fotovoltaica na Unidade Plásticos</p>
        </div>
      </div>
    </div>
  </div>

  <div class="block-text-three">
    <div class="wrap-max-width">
      <div class="block-content">
        <img src="/assets/images/imagem-maquina.png" alt="" class="imagem-mobile" />
        <h3 class="subtitle">Olhando para o Futuro</h3>
        <p class="description">
          Celebrar 35 anos é um marco, mas para a Blukit, é apenas o começo.
          Estamos continuamente investindo em pesquisa e desenvolvimento,
          novas tecnologias e capacitação de nossa equipe para enfrentar os desafios do futuro.
        </p>
        <p class="description">
          Como proposta de valor, nosso compromisso é simplificar a hidráulica com produtos inteligentes,
          sempre observando princípios éticos de atuação, que visa cuidar das pessoas e do meio ambiente através de recursos sustentáveis,
          entregando a todos os consumidores soluções inovadoras.
        </p>
      </div>
        <img src="/assets/images/imagem-maquina.png" alt="" class="imagem-desktop" />
      </div>
  </div>


  <div class="block-text-four">
    <div class="wrap-max-width">
      <div class="block-content">
        <h3 class="subtitle">Parceria</h3>
        <p class="description">
          Ao longo destes anos, construímos parcerias sólidas com fornecedores, lojistas e clientes, garantindo a perpetuação dos negócios.
        </p>
        <p class="description">
          Isso fez com que experimentássemos o sucesso de uma marca pautada em soluções e que nos levou a alcançar relevância no mercado da hidráulica.
        </p>
      </div>
    </div>
  </div>

  <div class="block-text-five">
    <div class="wrap-max-width">
      <div class="block-content">
        <h3 class="subtitle mt-1">Confiança</h3>
        <p class="description">
          A confiança que nossos parceiros e clientes depositam na Blukit é resultado de um trabalho transparente e
          de uma postura ética em todas as nossas relações comerciais. Valorizamos cada cliente e buscamos oferecer um atendimento personalizado,
          entendendo suas necessidades e oferecendo as melhores soluções.
        </p>
        <p class="description gap-bottom">
          A Blukit é uma empresa genuinamente brasileira, que além de atender todo o mercado nacional, exportamos nossos produtos para diversos
          países da América. Esta presença internacional reflete nossa capacidade de competir em um mercado cada vez mais exigente e dinâmico.
        </p>
      </div>
    </div>
  </div>

  <div class="block-text-six">
    <div class="wrap-max-width">
      <div class="block-content">
        <h3 class="subtitle">Missão</h3>
        <p class="description">
          Abastecer o mercado hidráulico com produtos inovadores, funcionais e de alta qualidade, prezando pela integridade das pessoas e do meio
          ambiente.
        </p>
      </div>
      <div class="block-content">
        <h3 class="subtitle">Visão</h3>
        <p class="description">
          Ter os produtos Blukit ao alcance de todos os consumidores do Brasil e América.
        </p>

      </div>
      <div class="block-content">
        <h3 class="subtitle">Proposta de Valor</h3>
        <p class="description">
          Nosso compromisso é simplificar a hidráulica com produtos inteligentes, sempre observando princípios éticos de atuação que
          visam cuidar das pessoas e do meio ambiente por meio do uso de recursos sustentáveis, entregando a todos os consumidores soluções inovadoras.
        </p>
      </div>
    </div>
  </div>


</section>
